
export const Categorydata = [
// HDPE Granules=====================
{
id: 1,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/1.png',
cateproduct_name: "PE 100 SSBK Granules",
catepro_desc: "PE 100: This likely stands for Polyethylene (PE) 100...",
catebtn_view: "Read More",
// 
catdtpro_name:'PE 100',
catdtpro_item:'SSBK',
catdtpro_mfi:'0.2-0.4',
catdtpro_density:'0.956-0.961',
catdtpro_ash:'<1%',
catdtpro_color:'BLACK',
catdtpro_usages:'PIPES AND EXTRUSION',
catdtpro_grade:'PE 100',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},

{
id: 2,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/2.png',
cateproduct_name: "PE 80 SBK Granules",
catepro_desc: "PE 80 SBK granules are a type of polyethylene (PE)...",
catebtn_view: "Read More",
// 
catdtpro_name:'PE 80',
catdtpro_item:'SBK',
catdtpro_mfi:'<1.0',
catdtpro_density:'0.965-0.972',
catdtpro_ash:'<1.5%',
catdtpro_color:'BLACK',
catdtpro_usages:'PIPES AND EXTRUSION',
catdtpro_grade:'PE 80',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},


{
id: 3,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/3.png',
cateproduct_name: "PE 63 BK Granules",
catepro_desc: "PE 63 BK granules refer to a specific type of polyethylene (PE)...",
catebtn_view: "Read More",
// 
catdtpro_name:'PE 63',
catdtpro_item:'BK',
catdtpro_mfi:'1.0-1.2',
catdtpro_density:'0.965-0.973',
catdtpro_ash:'<2%',
catdtpro_color:'BLACK',
catdtpro_usages:'PIPES AND EXTRUSION',
catdtpro_grade:'PE 63',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},


{
id: 4,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/4.png',
cateproduct_name: "BD (Blow Grade) Granules",
catepro_desc: "BD (Blow Grade) granules refer to a specific type of polyethylene (PE)...",
catebtn_view: "Read More",
// 
catdtpro_name:'BLOW',
catdtpro_item:'BD',
catdtpro_mfi:'1.5-2.5',
catdtpro_ash:'<4%',
catdtpro_color:'BLACK',
catdtpro_usages:'PIPES AND EXTRUSION',
catdtpro_grade:'HDPE BLOW',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},

{
id: 5,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/5.png',
cateproduct_name: "Natural Granules",
catepro_desc: "Natural granules typically refer to polyethylene (PE) granules...",
catebtn_view: "Read More",
// 
catdtpro_name:'NATURAL',
catdtpro_item:'NHD',
catdtpro_mfi:'1.5-2.5',
catdtpro_ash:'<2%',
catdtpro_color:'Natural',
catdtpro_usages:'PIPES AND EXTRUSION',
catdtpro_grade:'HDPE BLOW',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},


{
id: 6,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/6.png',
cateproduct_name: "Milky Granules",
catepro_desc: "Milky granules typically refer to polyethylene (PE) granules...",
catebtn_view: "Read More",
// 
catdtpro_name:'MILKY',
catdtpro_item:'MHD',
catdtpro_mfi:'1.5-2.5',
catdtpro_ash:'<3%',
catdtpro_color:'White',
catdtpro_usages:'PIPES AND EXTRUSION, Water Tanks',
catdtpro_grade:'HDPE BLOW',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},

{
id: 7,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/7.png',
cateproduct_name: "SSBL Blue Drum Granules",
catepro_desc: "SSBL Blue Drum Granules likely refer to a specific type of polyethylene...",
catebtn_view: "Read More",
// 
catdtpro_name:'BLUE DRUM',
catdtpro_item:'SSBL, SBL',
catdtpro_mfi:'0.2-0.4 & 1.0-1.20',
catdtpro_density:'0.956-0.961',
catdtpro_ash:'<1%',
catdtpro_color:'Blue',
catdtpro_usages:'PIPES AND EXTRUSION, DRUMS, WATER TANKS',
catdtpro_grade:'BLUE DRUM',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},

{
id: 8,
categoryname: 'HDPE Granules',
image: '../categoriesimg/hdpeimg/8.png',
cateproduct_name: "Custom Compounded Granules",
catepro_desc: "Custom compounded granules refer to polyethylene (PE) granules...",
catebtn_view: "Read More",
// 
catdtpro_name:'CUSTOM COMPOUNDING',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},

// HDPE Granules  end=====================


// LLDPE Granules =====================
{
id: 10,
categoryname: 'LLDPE Granules',
image: '../categoriesimg/lldpeimg/1.png',
cateproduct_name: "Cable Compounding N1 N2 granules",
catepro_desc: "Cable Compounding N1, N2 granules likely refers to specific...",
catebtn_view: "Read More",
// 
catdtpro_name:'CABLE COMPOUND N1, N2',
catdtpro_item:'N1,N2',
catdtpro_mfi:'~1.0',
catdtpro_ash:'<1.5%',
catdtpro_color:'BLACK',
catdtpro_usages:'CABLES AND OPTICAL FIBRES',
catdtpro_grade:'CABLE',
catdtpro_material:'HDPE EXTRUSION',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},
// LLDPE Granules end=====================


// PPCP Granules =====================
{
id: 11,
categoryname: 'PPCP Granules',
image: '../categoriesimg/ppcpimg/1.png',
cateproduct_name: "Black PPCP Granules",
catepro_desc: "Black PPCP granules refer to granules made from Polypropylene Copolymer (PPCP)...",
catebtn_view: "Read More",
// 
catdtpro_name:'BLACK PPCP',
catdtpro_item:'BKCP',
catdtpro_mfi:'6.0-8.0',
catdtpro_ash:'<4%',
catdtpro_color:'BLACK',
catdtpro_usages:'AUTOMOBILE PARTS , HOUSELHOLD ITEMS , COOLERS ,ETC',
catdtpro_grade:'PP',
catdtpro_material:'PPCP',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
},

{
id: 12,
categoryname: 'PPCP Granules',
image: '../categoriesimg/ppcpimg/2.png',
cateproduct_name: "Natural PPCP Granules",
catepro_desc: "Natural PPCP granules are granules made from Polypropylene Copolymer (PPCP)...",
catebtn_view: "Read More",
// 
catdtpro_name:'NATURAL',
catdtpro_item:'NCP',
catdtpro_mfi:'~25',
catdtpro_ash:'<0.5%',
catdtpro_color:'Natural, Dull Natural',
catdtpro_usages:'HOUSEHOLD ITEMS, ALL ARTICLE BASE ITEMS, COOLERS ETC.',
catdtpro_grade:'INJECTION PP',
catdtpro_material:'PPCP',
catdtpro_pacaging:'25 Kgs. Recyclable Coded Bags',
catdtpro_recycle:'Yes'
}
// PPCP Granules end=====================

// hdpedana start 


// hdpe dana end 


]


